import React from 'react';
import { Avatar, Typography } from "antd";
const { Text } = Typography;

const WithAvatar = ({ name, handleClick, className }) => {
    return (
        <div className='with-avatar'>
            {
                name && (
                    <>
                        <Avatar onClick={handleClick}>{name.split(' ')?.[0]?.[0]?.toUpperCase()}{name.split(' ')?.[1]?.[0]?.toUpperCase()}</Avatar>
                        <Text ellipsis={{tooltip: name}} className={className} onClick={handleClick}>{name}</Text>
                    </>
                )
            }
        </div>
    );
};

export default WithAvatar;